import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { PATH_ROOT } from "@/routes/paths";

import { LeftPanelCopy } from "./components/LeftPanelCopy";
import { WelcomeStageLayout } from "./components/WelcomeStageLayout";
import { WELCOME_TOTAL_STEPS } from "./constants";
import { isDemoWelcomeComplete } from "./demoWelcomeStorage";
import { INITIAL_DEMO_WELCOME_STATE, type DemoWelcomeState } from "./types";
import { useDemoWelcomeLaunch } from "./useDemoWelcomeLaunch";
import {
  StepAbout,
  StepConnect,
  StepInvite,
  StepPopulate,
  StepSignIn,
  StepWorkspace,
} from "./welcomeSteps";

export default function AriDemoWelcomePage() {
  const navigate = useNavigate();
  const launchDemo = useDemoWelcomeLaunch();
  const [step, setStep] = useState(0);
  const [state, setState] = useState<DemoWelcomeState>(INITIAL_DEMO_WELCOME_STATE);

  useEffect(() => {
    void isDemoWelcomeComplete().then((done) => {
      if (done) {
        navigate(PATH_ROOT.demo.inbox, { replace: true });
      }
    });
  }, [navigate]);

  const next = () => setStep((s) => Math.min(s + 1, WELCOME_TOTAL_STEPS - 1));
  const back = () => setStep((s) => Math.max(s - 1, 0));
  const isOwner = state.mode === "create";

  const launch = () => {
    void launchDemo(state);
  };

  const stepContent = [
    <StepSignIn key="sign-in" state={state} setState={setState} next={next} />,
    <StepAbout key="about" state={state} setState={setState} next={next} back={back} />,
    <StepWorkspace key="workspace" state={state} setState={setState} next={next} back={back} />,
    <StepInvite
      key="invite"
      state={state}
      setState={setState}
      next={next}
      back={back}
      isOwner={isOwner}
    />,
    <StepConnect key="connect" state={state} setState={setState} next={next} back={back} />,
    <StepPopulate key="populate" state={state} onLaunch={launch} />,
  ][step];

  return (
    <WelcomeStageLayout step={step} leftPanel={<LeftPanelCopy step={step} />}>
      {stepContent}
    </WelcomeStageLayout>
  );
}
